import React from "react";
import "./SideDrawer.css";

const SideDrawer = ({
  isOpen,
  toggleDrawer,
  filters,
  setFilters,
  resetFilters,
  filterOptions,
}) => {
  const handleClick = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: prev[key] === value ? "" : value,
    }));
  };

  return (
    <div className={`side-drawer ${isOpen ? "open" : ""}`}>
      <div className="side-drawer-header">
        <h3>Filters</h3>
        <button className="close-btn" onClick={toggleDrawer}>
          &times;
        </button>
      </div>

      {/* Category Filter */}
      {filterOptions.categories?.length > 0 && (
        <div className="filter-section">
          <h4>Category</h4>
          <div className="category-box">
            {filterOptions.categories.map((cat) => (
              <div
                key={cat}
                className={filters.category === cat ? "active" : ""}
                onClick={() => handleClick("category", cat)}
              >
                {cat}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Size Filter */}
      {filterOptions.sizes?.length > 0 && (
        <div className="filter-section">
          <h4>Size</h4>
          <ul className="size-box">
            {filterOptions.sizes.map((size) => (
              <li
                key={size}
                className={`size ${filters.size === size ? "active" : ""}`}
                onClick={() => handleClick("size", size)}
              >
                {size}
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Color Filter */}
      {filterOptions.colors?.length > 0 && (
        <div className="filter-section">
          <h4>Color</h4>
          <div className="color-box">
            {filterOptions.colors.map((clr) => (
              <div
                key={clr}
                className={filters.color === clr ? "active" : ""}
                onClick={() => handleClick("color", clr)}
              >
                {clr}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Optional: Show currently applied filters */}
      {(filters.category || filters.size || filters.color) && (
        <div className="applied-filters">
          <h5>Applied Filters:</h5>
          <div className="filter-tags">
            {filters.category && <span>{filters.category}</span>}
            {filters.size && <span>{filters.size}</span>}
            {filters.color && <span>{filters.color}</span>}
          </div>
        </div>
      )}

      <button className="reset-btn" onClick={resetFilters}>
        Reset Filters
      </button>
    </div>
  );
};

export default SideDrawer;
